import React, { useEffect, useState } from 'react';
import { MobileDownloadIcon } from "../Icons/icons";
import { IGenericDownload } from './types';
import { Grid, GridItem, GridRow, } from './../Grid';
import { Container, AssetPic, SuperText, TitleBig, Body, ButtonContainer, ImageContainer } from './styles';
import { getPictureSources } from '../../lib/utils/helpers';
import { CorporateButton } from './../CorporateButton';


export const CorpGenericDownload = ({
  id,
  superText,
  title,
  body,
  assetComponent,
  downloadableFile,
  label
}: IGenericDownload) => {
  const [screenWidth, setScreenWidth] = useState<number>(0);
  const screenSize = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    screenSize();
    window.addEventListener('load', screenSize);
    window.addEventListener('resize', screenSize);
    return () => window.removeEventListener('resize', screenSize);
  }, []);

  const mainContent = (
    <Container>
      <SuperText tag="div" type="lead" data-test={`${id}-superText`}>
        {superText}
      </SuperText>
      <TitleBig tag="div" type="xs" data-test={`${id}-title`}>
        {title}
      </TitleBig>
      <Body tag="div" type="md" data-test={`${id}-body`}>
        {body}
      </Body>
      <ButtonContainer data-test={`${id}-download-button`}>
        <form action={downloadableFile?.url} target="_blank">
          <CorporateButton color="tertiary" icon={<MobileDownloadIcon />} buttonType="submit" label={label || 'DOWNLOAD'} />
        </form>
      </ButtonContainer>
    </Container>
  );
  return (
    <Grid>
      <GridRow columns={16}>
        {assetComponent?.asset?.[0]?.mobile ? (
          <>
            <GridItem colStart={4} colSpan={10} className="border-b	border-heroCurve">
              <GridRow columns={10} className="pb-2.5 md:pb-5">
                <GridItem colStart={1} colSpan={screenWidth < 768 ? 10 : 3}>
                  <ImageContainer data-test={`${id}-image`}>
                    <AssetPic sources={getPictureSources(assetComponent.asset[0])} />
                  </ImageContainer>
                </GridItem>
                <GridItem colStart={4} colSpan={7} data-test={`${id}-all-written-content`}>
                  {mainContent}
                </GridItem>
              </GridRow>
            </GridItem>
          </>
        ) : (
          <>
            <GridItem colStart={4} colSpan={10} className="border-b	border-heroCurve">
              <GridRow columns={10} className="pb-2.5 md:pb-5">
                <GridItem colStart={1} colSpan={10} data-test={`${id}-all-written-content`}>
                  {mainContent}
                </GridItem>
              </GridRow>
            </GridItem>
          </>
        )}
      </GridRow>
    </Grid>
  );
};
